// extracted by mini-css-extract-plugin
export var bold = "ComponentStatus-module--bold--a0d0e";
export var iconCheck = "ComponentStatus-module--iconCheck--7dcf3";
export var iconChevron = "ComponentStatus-module--iconChevron--590ef";
export var link = "ComponentStatus-module--link--2d356";
export var scroll = "ComponentStatus-module--scroll--3ecb4";
export var table = "ComponentStatus-module--table--cdfb9";